import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ServicioService } from '../../services/servicio.service';

import { ModalController, IonRouterOutlet, LoadingController, AlertController } from '@ionic/angular';
import { IntroPage } from '../../pages/intro/intro.page';

// declare var $zopim: any;

@Component({
  selector: 'app-preventa',
  templateUrl: './preventa.page.html',
  styleUrls: ['./preventa.page.scss'],
})
export class PreventaPage implements OnInit {
  // @ViewChild('app-root', { static: true }) conten: AppComponent;

  pais = 'co';

  url;

  hasData = false;
  items: any = [];
  productos: any = [];
  productRows: any;

  constructor(
    private router: Router,
    private service: ServicioService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController

  ) { }

  ngOnInit() {
    // this.service.publishSomeData({
    //   ev: 'estilo'
    // });

  }

  async ionViewWillEnter() {
    this.service.getVariable('pais').then(res => {
      if (res !== undefined && res !== null) {
        this.pais = res;
      } else {
        this.pais = 'co';
        this.service.setVariable('pais', this.pais);
      }
    });

  }

  ionViewDidEnter() {
    // if (this.pais !== 'co') {
    //   const waitForZopim = setInterval(() => {
    //     if ($zopim === undefined || $zopim.livechat === undefined) {
    //       return;
    //     }
    //     $zopim(() => {
    //       $zopim.livechat.window.hide();
    //     });
    //     clearInterval(waitForZopim);
    //   }, 800);
    // }
  }

  async search(searchbar) {

    if (searchbar && searchbar.key === 'Enter') {

      const loader = await this.loadingCtrl.create(
        {
          spinner: 'bubbles',
          message: 'Cargando...'
        });
      await loader.present().then(async () => {
        const val1 = String(searchbar.srcElement.value).toUpperCase();
        if (val1.length < 3) {
          return;
        }

        let reload = false;
        if (searchbar.srcElement.formAction.includes('selector')) {
          reload = true;
        }

        this.service.getReferencia(this.pais, val1).then(async (data: any) => {
          if (data.length !== 0) {
            const params = {
              id1: val1
            }

            await this.guardarProductos(params);

            loader.dismiss();

          } else {
            loader.dismiss();
            const alert = await this.alertCtrl.create({
              header: 'Información',
              message: '¡ La referencia no se encuentra !',
              buttons: ['Aceptar']
            });
            await alert.present();
          }
        });
      });
    }
  }

  async guardarProductos(params: any): Promise<boolean> {

    const loader = await this.loadingCtrl.create(
      {
        spinner: 'bubbles',
        message: 'Obteniendo resultados...'
      });
    await loader.present().then(async () => {

      const respuesta = false;

      if (params !== undefined) {

        this.items = [];

        if (params.id1 !== undefined && params.id1 !== '') {
          await this.items.push(params.id1.toUpperCase());
        }
        if (params.id2 !== undefined && params.id2 !== '') {
          await this.items.push(params.id2.toUpperCase());
        }
        if (params.id3 !== undefined && params.id3 !== '') {
          await this.items.push(params.id3.toUpperCase());
        }
        if (params.id4 !== undefined && params.id4 !== '') {
          await this.items.push(params.id4.toUpperCase());
        }
        if (params.id5 !== undefined && params.id5 !== '') {
          await this.items.push(params.id5.toUpperCase());
        }
        if (params.id6 !== undefined && params.id6 !== '') {
          await this.items.push(params.id6.toUpperCase());
        }
        if (params.id7 !== undefined && params.id7 !== '') {
          await this.items.push(params.id7.toUpperCase());
        }
        if (params.id8 !== undefined && params.id8 !== '') {
          await this.items.push(params.id8.toUpperCase());
        }
        if (params.id9 !== undefined && params.id9 !== '') {
          await this.items.push(params.id9.toUpperCase());
        }
        if (params.id10 !== undefined && params.id10 !== '') {
          await this.items.push(params.id10.toUpperCase());
        }
        if (params.id11 !== undefined && params.id11 !== '') {
          await this.items.push(params.id11.toUpperCase());
        }
        if (params.id12 !== undefined && params.id12 !== '') {
          await this.items.push(params.id12.toUpperCase());
        }
        if (params.id13 !== undefined && params.id13 !== '') {
          await this.items.push(params.id13.toUpperCase());
        }
        if (params.id14 !== undefined && params.id14 !== '') {
          await this.items.push(params.id14.toUpperCase());
        }
        if (params.id15 !== undefined && params.id15 !== '') {
          await this.items.push(params.id15.toUpperCase());
        }

        if (this.items.length >= 1) {

          this.productos = [];

          this.items.forEach(async (element: any) => {

            await this.service.getReferencia(this.pais, element).then(async (data: any) => {

              if (data.length !== 0) {
                this.hasData = true;
                const item = {
                  parent: data[0].parent,
                  name: data[0].name,
                  retailPrice: data[0].retailPrice,
                  images: data[0].images,
                  items: data
                }
                this.productos.push(item);
                if (this.items.length === 1) {
                  this.service.setVariable('Referencia', this.productos[0].items);
                  if (this.pais === 'co') {
                    this.router.navigate(['producto/']);
                  } else {
                    this.router.navigate(['producto/' + this.pais + '/']);
                  }
                }

                this.productRows = Array.from(Array(Math.ceil(this.items.length / 2)).keys());

                await this.router.navigateByUrl('/home/', { replaceUrl: true });
                await this.router.navigateByUrl('/producto/' + this.pais + '/');

                loader.dismiss();
                if (this.productos.length > 0) {
                  return await this.service.setVariable('Referencia', this.productos.items).then(res => {
                    return res;
                  });
                }

              } else {
                loader.dismiss();
                const alert = await this.alertCtrl.create({
                  header: 'Información',
                  message: '¡ La referencia no se encuentra !',
                  buttons: ['Aceptar']
                });
                await alert.present();
                return false;
              }
            });
          });

        } else {
          this.hasData = false;
          loader.dismiss();
          return false;
        }

        // if (this.productos.length > 0) {
        //   return this.service.setVariable('Referencia', this.productos.items).then(res => {
        //     return res;
        //   });
        // }
      } else {
        loader.dismiss();
        return false;
      }

    });
    return true;
  }

}
